export const COLUMN_COUNT = 8;

export const MESSAGES = {
  CreateSuccess: 'Yay! A new group has been created successfully.',
  CreateFailure: 'Oops! Something went wrong while creating the group.',
  UpdateSuccess: 'Yay! Group details has been updated successfully.',
  UpdateFailure: 'Oops! Something went wrong while updating the group details.',
  LoadDetailFailure: 'Oops! Something went wrong while loading the group details.',
  DeleteSuccess: 'Yay! Group has been deleted successfully.',
  DeleteFailure: 'Oops! Something went wrong while deleting the group.',
  DeleteGroupDialogTitle: 'Delete group?',
  DeleteGroupDialogDescription:
    'Are you sure you want to delete this group? This action cannot be undone.',
  AddUserSuccess: 'User added successfully',
  AddUserFailure: 'Failed to add user',
  RemoveUserSuccess: 'User removed successfully',
  RemoveUserFailure: 'Failed to remove user',
  RemoveUserDialogTitle: 'Remove user from group?',
  RemoveUserDialogDescription:
    'Are you sure you want to remove this user from the group?',
  FormFieldRequiredError: 'This is a required field',
  FormFieldGroupNameLengthError: 'Group name should be longer than 4 characters',
};
